import React from 'react'
import HomeGuide from './HomeGuide'

export default ({children}) => {
  return <React.Fragment>{children}</React.Fragment>
}

export {HomeGuide}
